import { render, staticRenderFns } from "./Background4.vue?vue&type=template&id=4dd4de68&"
import script from "./Background4.vue?vue&type=script&lang=js&"
export * from "./Background4.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports